import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { persistStore } from 'redux-persist'
import persistReducers from './persistReducers'
import reducers from './reducers'
import sagas from './sagas'

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

const store = createStore(
  persistReducers(reducers),
  compose(applyMiddleware(...middlewares))
)
const persistor = persistStore(store)

sagaMiddleware.run(sagas)

if (module.hot) {
  module.hot.accept('./reducers', () => {
    store.replaceReducer(reducers)
  })
}

export { store, persistor }
